// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"91406919","977":"264c7fbf"}[chunkId] + ".chunk.js";
};